var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroupPro(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 169.7 192",
    style: {
      enableBackground: "new 0 0 169.7 192"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M131,68.9c0.9-0.5,2,0.1,2,1.1v54.7c0,0.6-0.3,1.2-0.9,1.5l-44.2,26.3c-0.9,0.5-2-0.1-2-1.1l-0.2-53.9 c0-0.9,0.5-1.7,1.3-2.2l29.9-18.1L131,68.9z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 11.9,
    cy: 53.3,
    r: 11.8
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 84.9,
    cy: 12.2,
    r: 11.8
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 158,
    cy: 55.3,
    r: 11.8
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 157.3,
    cy: 138.1,
    r: 11.8
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 84.9,
    cy: 180.6,
    r: 11.8
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 11.9,
    cy: 138.1,
    r: 11.8
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 9.4,
    y: 65.1,
    className: "st0",
    width: 5,
    height: 64.9
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "76,179.2 16,145.7 18.8,141 78.9,174.5  "
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "94.9,178.7 92.3,174.1 146.4,142 149,146.6  "
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 125.4,
    y: 92.8,
    transform: "matrix(1.179005e-02 -0.9999 0.9999 1.179005e-02 60.537 252.255)",
    className: "st0",
    width: 64.9,
    height: 5.5
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "149.2,53 88,17.2 90.8,12 152,47.8  "
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "63.6,26.2 60.7,21.5 75.1,14 78,18.7  "
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 42.3,
    y: 28.4,
    transform: "matrix(0.8874 -0.4609 0.4609 0.8874 -8.8412 25.5872)",
    className: "st0",
    width: 11.3,
    height: 5
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "20.8,50 18,45.1 33.6,36.1 36.4,41  "
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35.7,69.6l42.1,25.2c1.1,0.7,1.8,1.9,1.9,3.3l0.3,52.6c0,1.4-1.5,2.3-2.7,1.6l-42.7-25.5 c-0.9-0.6-1.5-1.6-1.5-2.6V71.2C33,69.8,34.5,68.9,35.7,69.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.4,64.9l43,24.5c0.7,0.4,1.6,0.4,2.3,0l43-25.5c1.5-0.9,1.5-3,0-4L84.2,33.8c-0.7-0.5-1.7-0.5-2.4,0L38.3,61 C36.8,61.9,36.8,64,38.4,64.9z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupPro);
export default __webpack_public_path__ + "static/media/GroupPro.e30c2a6ae8c3af7b7c3550ed582a18eb.svg";
export { ForwardRef as ReactComponent };